module.exports = __webpack_public_path__ + "static/media/mypic.3b3d6dd0.jpg";